<template>
  <!--58智能产品开始-->
  <div @contextmenu.prevent="handleContextmenu"
       :style="{width:isPC?'1198px':'100%'}"
       @touchstart="touchstarts()"
       @touchmove="touchmoves()"
       @touchend="touchends()">
    <!--正常内容 开始-->
    <div id="smart-intel-product">
      <!-- 区块标题 -->
      <tit :blockData="blockData"
           :src='rightSrc'
           @clear="clearSrc"
           @refesh="refeshData"
           @backFn="changeFlowTab"></tit>
      <div class="outreach_content" style="display:flex;">
      <!--左侧切换开始-->
          <left-tab v-show="isPC?'true':showLeftMenu"
                    v-if="(floorTabShow.indexOf('left')>-1)"
                    :Ind="leftTabInd"
                    :tabActiveType="tabActiveType"
                    :perNum="tabTopBottomLen"
                    :refeshflag="refeshflag"
                    :navHeight="rightContentHeight"
                    :tempNav="preTabListLeft"
                    :nav="nodeNavLeft"
                    :blockData="blockData"
                    :finalSequence="finalSequence"
                    @filterCons="filterCons"
                    @changePerson="changePerson"
                    @changeTab="changeFlowTab" />
          <!--左侧切换结束-->
        <div class="block-content clearfix"
             style="flex-grow:1;overflow:hidden;">
          <!-- 手机端显示按钮 -->
          <div class="btn-left"
               @click="showLeftMenu = true;"
               v-show="(floorTabShow.indexOf('left')>-1)"></div>
          <div class="btn-right"
               @click="showRightMenu = true;"
               v-show="(floorTabShow.indexOf('right')>-1)"></div>
          <div class="close-left"
               @click="showLeftMenu = false;"
               v-show="isPC?'true':showLeftMenu"></div>
          <div class="close-right"
               @click="showRightMenu = false;"
               v-show="isPC?'true':showRightMenu"></div>
          
          <!--右侧内容区开始-->
          <!-- <div class="right-content fl"
               ref='rightContent'
               :style="{width:isPC?`calc(100% - ${186*tabLeftRightLen+1}px)`:'100%'}"
               style="display:flex;flex-direction:column;"> -->
          <div class="right-content fl"
               ref='rightContent'
               style="display:flex;flex-direction:column;width:100%;">
            <!--顶部切换开始-->
            <top-tab v-if="(floorTabShow.indexOf('up')>-1)"
                     :Ind="leftTabInd"
                     :newAppId="newAppId"
                     :tabActiveType="tabActiveType"
                     :refeshflag="refeshflag"
                     :perNum="tabLeftRightLen"
                     :tempNav="preTabListTop"
                     :nav="nodeNavTop"
                     :newId="newId"
                     :basicTypes="basicTypes"
                     :blockData="blockData"
                     :finalSequence="finalSequence"
                     @changeTab="changeFlowTab"></top-tab>
            <!--顶部切换结束-->
            <!--主要内容开始-->
            <div v-if="!iframeSrc"
                 ref="centerEle"  @drop="dropInto($event)">
              <!-- 左右多图文 -->
              <expert v-if="centerStyle=='expertsAlliance'"
                      @emitHandleDetail="handleDetail"
                      @emitContextMenuItem="leftRightMove"
                      :tagsDataList="listData" />
              <!-- 多图展示 -->
              <enterpris v-else-if="centerStyle=='enterprisAlliance'"
                         @emitHandleDetail="handleDetail"
                         @emitContextMenuItem="leftRightMove"
                         :tagsDataList="listData" />
              <!-- 信息列表 -->
              <news v-else-if="centerStyle=='article'"
                    @emitHandleDetail="handleDetail"
                    @emitContextMenuItem="leftRightMove"
                    :tagsDataList="listData" />
              <!-- 同屏展示 -->
              <baseGroup v-else-if="centerStyle.indexOf('smartAppSameScreenShow')>-1"
                         @emitHandleDetail="handleDetail"
                         @emitContextMenuItem="leftRightMove"
                         :checkedItemId="checkedItemId"
                         :centerStyle="centerStyle"
                         :preNum="preNum"
                         :swiperInd="swiperInd"
                         :indexs="indexs"
                         :standList="standardListJson"
                         @arrowRight='arrowRight' />
              <!-- 多图遮罩/标准楼层 -->
              <smartApp v-else-if="centerStyle=='smartApp'||centers == 'banner'"
                        :centerStyle='centerStyle'
                        :blockData='blockData'
                        :blockCenterList='blockCenterList'
                        :tabActiveType="tabActiveType"
                        @emitHandleDetail="handleDetail"
                        :tabLeftRightLen="tabLeftRightLen"
                        :listData="listData"
                        @emitContextMenuItem="leftRightMove"
                        @emitChangeFlowTab='changeFlowTab'
                        :flowStep='flowStep'
                        :swiperInd='swiperInd+indexs'
                        @arrowRight='arrowRight' />
              <!-- 图文信息 -->
              <tradeNews v-else-if="centerStyle=='tradeNews'"
                         :centerStyle='centerStyle'
                         :blockCenterList='blockCenterList'
                         :blockData='blockData'
                         :listData="listData" />
              <!-- 多图文列表 -->
              <knowledgeCenter v-else-if="centerStyle=='knowledgeCenter'"
                               :centerStyle='centerStyle'
                               :blockData='blockData'
                               @emitHandleDetail="handleDetail"
                               @emitContextMenuItem="leftRightMove"
                               :listData="listData"
                               :tabLeftRightLen="tabLeftRightLen" />
              <!-- 流程架构 -->
              <baseGroupProcess v-else-if="centerStyle=='flowArchShow'"
                                :style="{height:'260px'}"
                                :centerStyle="centerStyle"
                                :preNum="preNum"
                                :swiperInd="swiperInd+indexs"
                                :standList="standardListJson"
                                @emitHandleDetail="handleDetail"
                                @emitContextMenuItem="leftRightMove" />
              <!-- 单图文展示/企业简介 -->
              <qyjjContent v-else-if="centerStyle=='companyIntroduce'"
                           :blockData='blockData' />
              <!-- 线型图 -->
              <smartChart v-else-if="centerStyle=='smartChart'"
                          :blockData='blockData'
                          ref='_changeFlowTab' />
              <!-- 横向列表区块 -->
              <horizontal v-else-if="centerStyle=='leftRightImgText'"
                          @emitHandleDetail="handleDetail"
                          @emitContextMenuItem="leftRightMove"
                          :listData='listData' />
              <!-- 小区块 -->
              <smallBlock v-else-if="centerStyle=='pictureImgText'"
                          @emitHandleDetail="handleDetail"
                          @emitContextMenuItem="leftRightMove"
                          :listData='listData' />
            </div>
            <!-- 个人信息页面开始 -->
            <div v-if="iframeSrc"
                 class="bottom-switch"
                 :class="[centerStyle,'smartAppSameScreenShow']">
              <!--切换一开始-->
              <iframe style="width:100%;height:100%;"
                      :src="iframeSrc"
                      frameborder="0"></iframe>
              <!--切换一结束-->
            </div>
            <!-- 个人信息页面结束 -->

            <!--主要内容结束-->
            <bottom-tab v-if="(floorTabShow.indexOf('down')>-1)"
                        :Ind="leftTabInd"
                        :newAppId="newAppId"
                        :tabActiveType="tabActiveType"
                        :refeshflag="refeshflag"
                        :perNum="tabLeftRightLen"
                        :tempNav="preTabListBottom"
                        :nav="nodeNavDown"
                        :newId="newId"
                        :basicTypes="basicTypes"
                        :blockData="blockData"
                        :finalSequence="finalSequence"
                        @changeTab="changeFlowTab"></bottom-tab>
          </div>
        </div>
        <!--右侧内容区结束-->
        <right-tab v-show="isPC?'true':showRightMenu"
                    v-if="(floorTabShow.indexOf('right')>-1)"
                    :Ind="leftTabInd"
                    :newAppId="newAppId"
                    :tabActiveType="tabActiveType"
                    :perNum="tabTopBottomLen"
                    :refeshflag="refeshflag"
                    :newId="newId"
                    :basicTypes="basicTypes"
                    :navHeight="rightContentHeight"
                    :tempNav="preTabListRight"
                    :nav="nodeNavRight"
                    :blockData="blockData"
                    :finalSequence="finalSequence"
                    @changeTab="changeFlowTab" />
      </div>
    </div>
    <!--正常内容 结束-->
  </div>
  <!--58智能产品结束-->
</template>

<script>
import Bus from '../../bus.js'
import tit from "./control/tit.vue"
import topTab from "./control/topTab.vue"
import bottomTab from "./control/bottomTab.vue"
import leftTab from "./control/leftTab.vue"
import rightTab from "./control/rightTab.vue"
import expert from "./expert.vue"
import enterpris from "./enterpris.vue"
import news from "./news.vue"
import knowledgeCenter from "./knowledgeCenter.vue"
import baseGroup from "./baseGroup.vue"
import baseGroupProcess from "./baseGroupProcess.vue"
import ZImage from "../ZImage.vue"
import smartApp from "./smartApp.vue"
import tradeNews from "./tradeNews.vue"
import smartChart from "./smartChart.vue"
import qyjjContent from "./qyjjContent.vue"
import horizontal from "./horizontal_list.vue"
import smallBlock from "./small_block.vue"
export default {
  name: 'zncpMain',
  components: {
    tit: tit,
    topTab,
    bottomTab,
    leftTab,
    rightTab,
    expert,
    enterpris,
    ZImage,
    news,
    knowledgeCenter,
    baseGroup,
    smartApp,
    tradeNews,
    qyjjContent,
    smartChart,
    horizontal,
    smallBlock,
    baseGroupProcess
  },
  props: {
    blockData: {
      type: Object
    },
    _centerStyle: {
      require: true,
      default: "smartApp"
    },
    baseNavHeight: {
      type: Number,
      default: 425
    },
    indexs: Number
  },
  data () {
    return {
      checkedItemId:{id:''},
      getContent:0,
      centerChoose:false,
      nowLength: 0,
      nowFlowTab: {},
      pageNum: 1,
      timeOutEvent: 0,
      rightSrc: '',
      height: '',
      heights: '',
      centers: '',
      iframeSrc: '',
      mySwiper: undefined,
      swiperInd: this.blockData.id,
      showLeftMenu: false,
      showRightMenu: false,
      tagsMenuPos: {
        left: 0,
        top: 0
      },
      tagsShow: false,
      tagsName: [],
      tagsValue: [],
      leftTabInd: 0,
      topTabInd: 0,
      listData: [],
      showList: false,
      refeshflag: false,
      tempNav: [],
      nodeNav: [],
      nodeNavTop: [],
      nodeNavLeft: [],
      nodeNavRight: [],
      nodeNavDown: [],
      blockId: '',
      flowId: '',
      nodeId: '',
      contentId: '',
      flowNewList: [],
      flowStep: 1,//1代表流程，2代表平台,3代表平台详情
      ProjectInfo: null,
      professionId: '',
      mainFlowJson: [
        { name: '创建业务', url: '/acnid-project-approve/scenarioinfo/bsysprofession/edit_business?professionId=' },
        { name: '选择场景', url: '/acnid-project-approve/scenarioinfo/bsysscenegroup/myscenelist?selectSceneGroupFrame=selectSceneGroupFrame&beforeProfessionId=' },
        { name: '场景商圈调整', url: '/acnid-project-approve/scenarioinfo/circlelibrary/list?groupId=iaiid-ZNKFZPT000000000000guru1601023894000156002&professionId=' },
        { name: '交付物配置', url: '/acnid-project-approve/profession/deliverable/list?groupId=iaiid-ZNKFZPT000000000000guru1601023894000156002&flag=1&professionId=' },
        { name: '时间配置', url: '/acnid-project-approve/profession/time/list?groupId=iaiid-ZNKFZPT000000000000guru1601023894000156002&flag=1&professionId=' },
        { name: '场景、交付物、考核、时间架构调整', url: '/acnid-project-approve//scenarioinfo/sdatimeframeconfig/list?groupId=iaiid-ZNKFZPT000000000000guru1601023894000156002&professionId=' },
        { name: '业务平台入库', url: '/acnid-project-approve/scenarioinfo/bsysprofession/business_platform_putIn?professionId=' }
      ],
      treeOragin: [],
      treeData: [],
      table: {
        options: []
      },
      floorTabShow: '',
      floorDetailShow: '',
      noData: false,
      preTabListTop: [],
      preTabListLeft: [],
      preTabListRight: [],
      preTabListBottom: [],
      preStep: 0,
      tabTopBottomLen: 0,
      tabLeftRightLen: 1,
      tabActiveType: 'center',
      preNum:  window.innerWidth <= 768 ? 2 : 5,
      timer: null,
      blockCenterList: [],
      screenWidth: document.documentElement.clientWidth,//屏幕宽度
      standardListJson: [],
      canAddCircleData: true,
      candliverProp: true,
      isQuote: false,
      circleTabList: [],
      centerStyles: '',
      rightContentHeight: '',
      centerStyle: '',
      data: [],
      flowType: '',
      changeFlowBlock: '',
      numReduce: false,
      addContent: false,
      finalSequence: [],
      priorityData:[],//优先级数据
      centerContent:false,//中间块数据
      newAppId:'',
      newId:'',
      basicTypes:false,
      imitate:false,
      upBlockId:'',
      defaultBlockId:''
    }
  },
  watch: {
    preStep: function (val) {
      if (val == 2) {
        if (this.blockData.flowSlideshow == 'on') {
          this.nodeNav = [...this.preTabList, ...this.blockData.dataArr];
          this.tempNav = [...this.preTabList, ...this.blockData.dataArr];
        } else {
          this.nodeNav = [...this.preTabList];
          this.tempNav = [...this.preTabList];
        }
        // this.changeFlowTab(this.nodeNav[0],{refesh:false,activeTab:0,tabType:'top'});
      }
    },
    //右键搜索框内容
    '$store.state.searchContent': function (val) {
      if (val && this.blockData.id == window.$search.floor) {
        this.changeFlowTab(window.$search.item, { refesh: true, activeTab: '', tabType: window.$search.area }, val ? val : '');
      }
    },
    getContent:function(val){
      if(val == (this.floorTabShow.split(',').length - 1) && this.centerChoose){
        this.getCenterContent();
      }
    },
    floorTabShow:function(val){
      this.setTagData();
      this.swiperFn();
    }
  },
  computed: {
    isPC () {
      if (window.innerWidth > 768) {
        // if (window.innerWidth) {
        return true;
      } else { return false; }
    },
    tagData () {
      return this.$store.state.tagData;
    }
  },
  mounted () {
    this.centerStyles = this._centerStyle;
    this.centerStyle = this._centerStyle;
    var _this = this;
    // this.swiperInd = this.blockData.sno;
    //添加 第一个主流程tab名称
    var { id, flowType, code, appId, name, pcode, floorType } = this.blockData;
    var Mainitem = { id, flowType, code, appId, name, pcode, floorType, tabType: 'main' };
    this.blockData.dataArr.unshift(Mainitem);

    this.filterTagData2(this.blockData.dataArr);
    // this.getFloorShowStyle(id)
    //tab选中 逻辑 读取上下左右中间勾选展示 默认中间，如果没有中间则按照上左右
    this.getTabBlock(id,'','','','first');

    window.addEventListener('resize', function () {
      _this.screenWidth = document.body.offsetWidth;
      if(window.innerWidth <= 768){
        _this.swiperFn();
      }
    })

    this.baseFloorType = this.$store.state.platFormType;
    //监听中间块高度
    var elementResizeDetectorMaker = require("element-resize-detector");
    var erd = elementResizeDetectorMaker();
    //监听整体高度
    erd.listenTo(this.$refs.rightContent, function (element) {
      _this.rightContentHeight = element.clientHeight;
    })
    //监听中心展示高度
    erd.listenTo(this.$refs.centerEle, function (element) {
      _this.heights = element.clientHeight;
    })


    //改变楼层信息
    // Bus.$on('changeFloorContent', (t) => {
    //   switch (t.orgType) {
    //     case '1':
    //       if (_this.blockData.flowEnName == 'main-products') {
    //         _this.changeFlowTab(t, { refesh: true, activeTab: 0, tabType: '' }, '', 'header');
    //       }
    //       break;
    //     case '2':
    //       if (_this.blockData.flowEnName == 'related-products') {
    //         _this.changeFlowTab(t, { refesh: true, activeTab: 0, tabType: '' }, '', 'header');
    //       }
    //       break;
    //     case '3':
    //       if (_this.blockData.flowEnName == 'project-products') {
    //         _this.changeFlowTab(t, { refesh: true, activeTab: 0, tabType: '' }, '', 'header');
    //       }
    //       break;
    //   }
    // });
    
    //跳转刷一刷页面
    Bus.$on('rightSlide',(t)=>{
      if(t == _this.blockData.id){
        _this.routerJump('push','detail',{appId:_this.getQuery('appId'),floorflowId:_this.blockData.id,flowEnName:_this.blockData.flowEnName,isMedia:(_this.blockData.flowEnName=='media-scene' ?'1':''),brush:1,pfId:window.$pfId,zzBlockId:_this.basicTypes?'':_this.newId,zxBlockId:_this.basicTypes?_this.newId:'',newAppId:this.basicTypes?'':this.newAppId},'体验');
        // _this.routerJump('push','odzid',{appId:_this.getQuery('appId'),floorflowId:_this.blockData.id,flowEnName:_this.blockData.flowEnName,isMedia:(_this.blockData.flowEnName=='media-scene' ?'1':''),brush:1,pfId:window.$pfId,zzBlockId:_this.basicTypes?'':_this.newId,zxBlockId:_this.basicTypes?_this.newId:'',newAppId:this.basicTypes?'':this.newAppId},'刷一刷');
      }
    })
  },
  methods: {
    dropInto(e){
      e.preventDefault();
      var deviceId = JSON.parse(e.dataTransfer.getData("deviceId"));
      var checkedItemId = deviceId.checkedItemId; //流程或流程块id
      if(checkedItemId != this.checkedItemId.id && this.$store.state.userInfo.userId){
        this.$http
        .get("/zciid-deliverable/api/search/drop/data", {
          id:deviceId.id?deviceId.id:'',//交付物id
          blockId : this.checkedItemId.id,
          userId:this.$store.state.userInfo.userId,
          appId:this.getQuery('appId'),
          name:deviceId.title ? deviceId.title : '',
          url:deviceId.url ? deviceId.url : '',
          img:deviceId.img ? deviceId.img : '',
          price:deviceId.price ? deviceId.price : '',
          env:deviceId.env ? deviceId.env : ''
        }).then(()=>{
          // if(this.checkedItemId.pfId){
          //   this.getTagsByFlowId (this.checkedItemId.fId, this.checkedItemId.pageNum, this.checkedItemId.param, this.checkedItemId.datas, this.checkedItemId.keyWord, this.checkedItemId.item, this.checkedItemId.area)
          // }else{
          //   this.getTagsByBlockId (this.checkedItemId.item, this.checkedItemId.param, this.checkedItemId.keyWord)
          // }
          this.refeshData();
        })
      }else{
        if(!this.$store.state.userInfo.userId){
          this.$notify({
            title: '提示',
            message: '请登录后使用此功能',
            type: 'warning',
            duration: 5000
          });
          return;
        }
        if(checkedItemId == this.checkedItemId.id){
          this.$notify({
            title: '提示',
            message: '禁止拖拽',
            type: 'warning',
            duration: 5000
          });
          return;
        }
      }
      
    },
    touchstarts () {
      var _this = this;
      // 长按事件触发
      clearTimeout(_this.timeOutEvent);
      _this.timeOutEvent = setTimeout(function () {
        _this.timeOutEvent = 0;
        _this.handleContextmenu();
      }, 400);
      //长按400毫秒
      // e.preventDefault();
    },
    touchmoves () {
      clearTimeout(this.timeOutEvent);
      this.timeOutEvent = 0;
    },
    touchends (e) {
      clearTimeout(this.timeOutEvent);
      return false;
    },
    filterCons(keyWord){
      if(!keyWord) {
        this.nodeNavLeft = this.preTabListLeft;
        return;
      }
      //左侧筛选
      this.$http
        .get("/zciid-deliverable/api/showPlatform/content/getWzCassAppByDataType.json", {
          keyWord: keyWord,
          appId:this.getQuery('appId'),
          floorEnName:this.blockData.flowEnName
        }).then(res =>{
          this.$http
          .get("/zciid-deliverable/api/showPlatform/content/getLeftKeyWordByFloorEnName.json", {
            keyWord: keyWord,
            appId:this.getQuery('appId'),
            floorEnName:this.blockData.flowEnName
          }).then(req => {
              this.nodeNavLeft = [...(res.state == 1 && res.data.length ? res.data : ''),...req.state == 1 && req.data.length ? req.data : ''];
          })
        })
    },
    getCenterContent(){
      //第三方不请求
      if(this.basicTypes) return;
      this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/getContentByAppIdAndFlowId", {
          appId: this.getQuery('appId'),
          flowId:this.blockData.id,
          floorType:'center',
          pageNum:this.pageNum,
          pageSize:this.preNum
        }).then(res => {
          if (res.state == 1) {
            this.nowLength = res.data.length;
            this.centerContent = true;
            this.getProduct(res.data);
          }else{
            this.getProduct()
          }
        })
    },
    //关闭中心iframe
    clearSrc () {
      this.rightSrc = '';
      // this.swiperFn();
    },
    //跳转个人信息页面
    changePerson (item) {
      //通过
      this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/get/getFlowByUserId.json", {
          // appId: this.blockData.appId,
          appId: this.getQuery('appId'),
          userId: item.userId,
        }).then(res => {
          if (res.state == 1) {
            this.nodeNavTop = res.data;
          }
        })
      this.iframeSrc = 'https://cms.520emv.com/acnid-project-approve/bsys/commonchooseUser/tsyscircleuser/myInfo?userId=' + item.userId;
    },
    setTagData () {
      var tableft = this.floorTabShow.indexOf('left') > -1;
      var tabright = this.floorTabShow.indexOf('right') > -1;

      var tabbottom = (this.floorTabShow.indexOf('down') > -1);
      var tabtop = (this.floorTabShow.indexOf('up') > -1);

      var preNum = 5;
      var Len = 0;
      var tbLen = 0;
      if (tableft || tabright) {
        Len = 1;
        preNum = 4;
        if (tableft && tabright) {
          Len = 2;
          preNum = 3;
        }
      }
      if (tabbottom || tabtop) {
        tbLen = 1;
        if (tabbottom && tabtop) {
          tbLen = 2;
        }
      }

      if (window.innerWidth <= 768) {
        tbLen = 0;
        Len = 0;
      }
      if (window.innerWidth <= 768 && (this.centerStyle != 'banner' || this.centerStyle != 'companyIntroduce')) {
        preNum = 2;
      }
      this.preNum = preNum;
      this.tabLeftRightLen = Len;
      this.tabTopBottomLen = tbLen;
    },
    handleContextmenu () {
      window.$search = {};
      this.$store.commit('setFlowType', this.blockData.floorType);
      window.$floorflowId = this.blockData;
      window.$defaultBlockId = this.defaultBlockId;
      this.$flowId = this.blockData.id;
      window.$floorId = this.flowId;
      window.$nodeId = this.nodeId;
      window.$blockId = this.blockId;
      Bus.$emit('sendCircleType', { circle: this.canAddCircleData, dliverProp: this.candliverProp });
      Bus.$emit('banner', '');
    },
    parse (list) {
      return JSON.parse(list)[0].pmName;
    },
    //左移右移
    leftRightMove (ind, ev, name) {
      //记录右键点击交付物
      window.$selectLi = $(ev.target);
      this.handleContextmenu();
      this.$store.commit('setFlowType', this.blockData.floorType);
      const item = this.standardListJson[ind];
      window.$item = this.listData[ind];
      window.$floorflowId = this.blockData;
      window.$contentWzUrl = item.contentWzUrl ? item.contentWzUrl : item.contentDsfWzUrl;
      window.$releaseId = item.contentId ? item.contentId : '';
      window.$nodeId = item.nodeId;
      window.$dataType = item.sign;
      window.$blockId = item.blockId;
      window.$isYyz = parseInt(item.isYyz);
      window.$isBlock = this.blockData.flowEnName == 'meta-universe' ? 'yes' : '';
      window.outerName = name;
      Bus.$emit('windowRight', ev, item,this.blockData.flowEnName);
      var left = {}, center = {}, right = {};
      if (ind > 0) {
        var leftItem = this.standardListJson[ind - 1];
        if (leftItem && leftItem.contentId) {
          left = {
            blockId: leftItem.blockId,
            contentId: leftItem.contentId,
            contentShowRowsSort: leftItem.contentShowRowsSort
          };
        }
      }
      if (ind < this.standardListJson.length) {
        var rightItem = this.standardListJson[ind + 1];
        if (rightItem && rightItem.contentId) {
          right = {
            blockId: rightItem.blockId,
            contentId: rightItem.contentId,
            contentShowRowsSort: rightItem.contentShowRowsSort
          };
        }
      }
      if (item) {
        center = {
          item: item,
          blockId: item.blockId,
          contentId: item.contentId,
          contentShowRowsSort: ind,
          standardJson: item.standardJson
        }
        if(item.contentId){
          this.$http
          .get('/zciid-deliverable/showPlatformStyle/flow/api/get/getContentByIdAndStandardId.json', {
            contentId: item.contentId
          })
          .then(res => {
            if (res.state == 1) {
              window.$otherDatas = res.data;
            }
          });
        }
      }

      var rightLeft = {
        left: left,
        center: center,
        right: right
      }

      Bus.$emit('sendCircleType', { circle: this.canAddCircleData, dliverProp: this.candliverProp });
      window.$rightLeft = rightLeft;
    },
    //通过 上下左右映射 ajax types的值
    getMapValuesByFloorTabType (floorTabShow = 'down',def) {
      var type = 'flow-nav-prioroty';
      switch (floorTabShow) {
        case 'center':
          type = def ? 'flow-center-default' : 'floor-center-prioroty';
          break;
        case 'up':
          type = this.basicTypes ? 'third-flow-up' : (def ? 'flow-up-default' : 'flow-nav-prioroty');
          break;
        case 'left':
          type = def ? 'flow-left-default' : 'floor-left-prioroty';
          break;
        case 'right':
          type = def ? 'flow-right-default' : 'floor-right-prioroty';
          break;
        case 'down':
          type = this.basicTypes ? 'third-flow-down' : (def ? 'flow-down-default' : 'floor-bottom-prioroty');
          break;
        default:
          type = 'flow-nav-prioroty';
      }
      return type;
    },
    //获取楼层左侧右键勾选的流程、流程块、商圈
    getLeftCircleSelectValues (item = {}) {
      const _this = this;
      return this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/get/getFloorLeftFlowAndCircle.json", {
          // appId: _this.blockData.appId,
          appId: _this.getQuery('appId'),
          flowId: _this.blockData.id,
          navType: 'floor-left-prioroty',
          clickFlowId: item.id ? item.id : ''
        })
    },
    //通过上下左右 设置对应的tab勾选数据
    setTabValuesByFloorTabType (floorTabShow, list = [], first,priorityData,state) {
      var _this = this;
      //是第三方不默认
      // if(_this.basicTypes){
      //   _this.finalSequence = [];
      // }
      
      const tabItemParam = { refesh: false, activeTab: 0, tabType: first };
      switch (floorTabShow) {
        case 'center':
          if (first == 'center') {
          //   this.blockCenterList = list.length ? list : this.blockData.dataArr;
          //   // this.tabActiveType = 'center';
          //   if (first == 'center' && list.length == 0) {
          //     if(priorityData.length){
          //       this.getProduct(priorityData);
          //     }else{
          //       this.changeFlowTab(this.blockData.dataArr[0], tabItemParam);
          //     }
          //   }
          //   this.swiperFn();
            this.getCenterContent();
          }
          break;
        case 'up':
          if (list.length) {
            list.forEach((ite) => {
              ite.tabType = 'check';
            })
          }

          if (this.blockData.flowSlideshow == 'on') {
            //勾选上端默认
            this.nodeNavTop = [...list, ...this.blockData.dataArr];
            this.preTabListTop = [...list, ...this.blockData.dataArr];
          } else {
            this.nodeNavTop = list;
            this.preTabListTop = list;
          }
          if (first == 'up' && !state) {
          // if (first == 'up' && !_this.basicTypes) {
            if(priorityData.length){
              this.getProduct(priorityData)
            }else{
              this.changeFlowTab(this.nodeNavTop[0], tabItemParam);
            }
          }
          break;
        case 'left':
          // var leftRes = this.getLeftCircleSelectValues();
          // _this.preTabListLeft = [];
          // _this.nodeNavLeft = [];
          // leftRes.then(res => {
          //   if (res.state == 1) {
          //     _this.isQuote = true;
          //     if (res.data.childFlowArr) {
          //       _this.nodeNavLeft.unshift(...res.data.childFlowArr);
          //       _this.preTabListLeft.unshift(...res.data.childFlowArr);
          //     }

          //     if (res.data.circleArr) {
          //       _this.nodeNavLeft.unshift(...res.data.circleArr);
          //       _this.preTabListLeft.unshift(...res.data.circleArr);
          //     }

          //   } else {
          //     _this.preTabListLeft = list;
          //     _this.nodeNavLeft = list;
          //   }
          // })
          _this.preTabListLeft = list;
          _this.nodeNavLeft = list;
          // if (first == 'left' && !_this.basicTypes) {
          if (first == 'left'&& !state) {
            if(priorityData.length){
              this.getProduct(priorityData)
            }else{
              this.changeFlowTab(list[0], tabItemParam);
            }
          }
          break;
        case 'right':
          this.preTabListRight = list;
          this.nodeNavRight = list;
          if (first == 'right'&& !state) {
          // if (first == 'right' && !_this.basicTypes) {
            if(priorityData.length){
              this.getProduct(priorityData)
            }else{
              this.changeFlowTab(list[0], tabItemParam);
            }
          }
          break;
        case 'down':
          this.preTabListBottom = list;
          this.nodeNavDown = list;
          if (first == 'down' && !state) {
          // if (first == 'down' && !_this.basicTypes) {
            if(priorityData.length){
              this.getProduct(priorityData)
            }else{
              this.changeFlowTab(list[0], tabItemParam);
            }
          }
          break;
        default:
          if(priorityData.length){
            this.getProduct(priorityData)
          }
          break;
      }
    },
    getPriorityData(){
      //获取优先级交付物
      this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/getConfigContentByAppId.json", {
          appId: this.getQuery('appId'),
          types: this.blockData.flowEnName,
          pageSize: this.preNum,
          pageNum: this.pageNum,
          leftId: this.newId,
          floorEnName:this.blockData.flowEnName
        }).then(res => {
          if(res.state == 1){
            this.getProduct(res.data);
          }
        })
    },
    //获取上下左右
    async getTabBlock (id ,item, param, searchValue,first) {
      if(!this.newAppId && !this.basicTypes){
        //刷新重置
        this.floorTabShow = '';
      }
      var _this = this;
      var url = "/zciid-deliverable/showPlatformStyle/flow/api/getShowFlowPosition.json",
      data = {
          appId: _this.newId == 'falseBlockId' ? _this.newAppId : _this.getQuery('appId'),
          // appId: _this.getQuery('appId'),
          flowId: id,
          flowOrDetail: 'flow',
          domainNameType: document.location.pathname.split('/')[1],
          leftId: _this.basicTypes ? '' : _this.newId
        }
      if(first){
        //选择默认第三方逻辑，直接显示第三方内容
        let resq = await _this.$http.get('/zciid-deliverable/api/abduction/getFloorDefaultByFloorFlowId.json', { appId:_this.$appId,floorFlowId:_this.blockData.id });
        let res = await _this.$http.get(url, data);
        _this.imitate = res.data;
        if(resq.state == 1){
          _this.defaultBlockId = resq.data.id;
          if(res.data.indexOf('left') > -1){
            _this.floorTabShow = 'left';
            _this.getSelectTabFlowAndBlock(id, 'left', 'left',_this.priorityData);
          }
          //直接触发流程块
          _this.changeFlowTab(resq.data,{activeTab: undefined,refesh: true,tabType: "left"});
          return;
        }
      }
      if(_this.basicTypes){
        url = "/zciid-deliverable/api/abduction/dsfSelectShowFlowPosition.json";
        delete data.domainNameType;
        delete data.leftId;
        data.flowOrDetail = 'dsfFlow';
        data.dsfBlockId = _this.newId;
      }
      this.$http
        .get(url,data).then(res => {
          _this.floorTabShow = res.data ? res.data : '';
          // if((_this.newAppId || _this.basicTypes && _this.floorTabShow.indexOf('left') == -1)){
          if((_this.newAppId || _this.basicTypes && _this.floorTabShow.indexOf('left') == -1) && _this.imitate.indexOf('left') > -1){
            //查看他人交付物时左侧不变
            _this.floorTabShow+=',left';
          }
          if(_this.basicTypes){
            //第三方没有勾上下侧请求交付物
            var array = ['up', 'down', 'right'].filter((tags) => res.data.indexOf(tags) > -1);
            if(!array.length){
              this.getTagsByBlockId(item, param, searchValue);
            }
          }
          return _this.$blockGetData.getActiveType(res.data, _this.blockData.flowEnName);
        }).then((tablist) => {
          //根据 返回勾选进行中间块标签块请求 
          // 1. 标准楼层中间块暂时 不能进行标签请求
          // 2. 数据请求按照中间、上、左、右、下勾选顺序进行请求
          // 2. 数据请求按照中间、下、右、左勾选顺序进行请求
          // 3. 当无数据使用空数据进行填充
          //整理后顺序
            _this.setTagData();
            const center = tablist.indexOf('center');
            if(center){
              //判断是否勾选中间块
              _this.centerChoose = true;
            }
            const index = tablist.indexOf('left');
            // newAppId为流程块的appId
            if (index > -1 && (_this.newAppId || _this.basicTypes)) {
              //查看他人交付物时左侧不变
              tablist.splice(index, 1);
            }
            if(_this.basicTypes){
              //第二个优先级接口
              var url = "/zciid-deliverable/api/showPlatform/content/getNewBrushContentByFloorId.json",data={
                  appId: this.getQuery('appId'),
                  floorId:this.blockData.id,
                  floorEnName:this.blockData.flowEnName,
                  pfId:window.$pfId,
                  pageSize: this.preNum,
                  pageNum: this.pageNum,
                },
                //取消楼层默认选中
                arr = ['main-products','data-asset','organizational-assets','platform-assets','special-asset','window-asset'];
                if(arr.includes(this.blockData.flowEnName)){
                  url = '/zciid-deliverable/api/showPlatform/content/getWzFloorBrushContent.json',
                  data={
                    appId: this.getQuery('appId'),
                    flowId:this.blockData.id,
                    pfId: window.$pfId,
                    sort: -1,
                    zzBlockId: _this.newId,
                    newAppId: _this.newAppId,
                    pageSize: this.preNum,
                    pageNum: this.pageNum,
                  }
                }
              this.$http
                .get(url, data).then(res => {
                  if(res.state == 1){
                    this.getProduct(res.data);
                  }else{
                      _this.finalSequence = tablist;
                  }
                  tablist.map((tab) => {
                    _this.getSelectTabFlowAndBlock(id, tab, tablist[0],_this.priorityData,res.state);
                  })
                })
              return;
            }
            //获取第一个优先级交付物
            _this.$http
              .get("/zciid-deliverable/showPlatformStyle/flow/api/getConfigContentByAppId.json", {
                appId: _this.newAppId ? _this.newAppId : _this.getQuery('appId'),
                types: _this.blockData.flowEnName,
                pageSize: _this.preNum,
                pageNum: 1 ,
                leftId: _this.basicTypes ? '' : _this.newId,
                floorEnName:_this.blockData.flowEnName
              }).then(res => {
                if(res.state == 1){
                  _this.nowLength =  res.data.length;
                  _this.priorityData = res.data;
                }else{
                //第二个优先级接口
                var url = "/zciid-deliverable/api/showPlatform/content/getNewBrushContentByFloorId.json",data={
                  appId: this.getQuery('appId'),
                  floorId:this.blockData.id,
                  floorEnName:this.blockData.flowEnName,
                  pfId:window.$pfId,
                  pageSize: this.preNum,
                  pageNum: this.pageNum,
                },
                //取消楼层默认选中
                arr = ['main-products','data-asset','organizational-assets','platform-assets','special-asset','window-asset'];
                if(arr.includes(this.blockData.flowEnName)){
                  url = '/zciid-deliverable/api/showPlatform/content/getWzFloorBrushContent.json',
                  data={
                    appId: this.getQuery('appId'),
                    flowId:this.blockData.id,
                    pfId: window.$pfId,
                    sort: -1,
                    zzBlockId: _this.newId,
                    newAppId: _this.newAppId,
                    pageSize: this.preNum,
                    pageNum: this.pageNum,
                  }
                }
                this.$http
                .get(url, data).then(res => {
                  if(res.state == 1){
                    this.getProduct(res.data);
                  }else{
                    _this.finalSequence = tablist;
                  }
                  tablist.map((tab) => {
                    _this.getSelectTabFlowAndBlock(id, tab, tablist[0],_this.priorityData,res.state);
                  })
                })
              }
                
                
                // _this.swiperFn();
              })
            
        })

      // this.$http
      //   .get("/zciid-deliverable/showPlatformStyle/flow/api/getShowFlowPosition.json", {
      //     appId: _this.newAppId ? _this.newAppId : _this.getQuery('appId'),
      //     flowId: id,
      //     flowOrDetail: 'detail',
      //     domainNameType: document.location.pathname.split('/')[1],
      //     leftId: _this.basicTypes ? '' : _this.newId
      //   }).then(res => {
      //     _this.floorDetailShow = res.data ? res.data : 'down'
      //   })
    },
    getSelectTabFlowAndBlock (fId, tab, firstTab,priorityData,state) {
      const _this = this;
      var tabtype = this.getMapValuesByFloorTabType(tab);
      var url = "/zciid-deliverable/showPlatformStyle/flow/api/get/getMainTopNavList.json",
      data = {
          appId: _this.newId == 'falseBlockId' ? _this.newAppId : _this.$appId,
          // appId: _this.$appId,
          types: tabtype,
          flowId: fId,
          isBlock: _this.blockData.flowEnName == 'meta-universe' ? 'yes' : '',
          leftId: _this.basicTypes ? '' : _this.newId,
          // dsfBlockId:_this.basicTypes ? _this.blockId : ''
          dsfBlockId:_this.basicTypes ? _this.newId : ''
      }
      this.$http
        .get(url, data).then((res) => {
          
          if(this.basicTypes){
            //第三方不请求默认
            if (res.state == 1 || priorityData) {
              _this.setTabValuesByFloorTabType(tab, [...(res.data ? res.data : '')], firstTab,priorityData,state);
            }else if( !res.state && !_this.newAppId ){
              _this.getContent ++ ;
            }
            return;
          }  
          //除第三方外请求默认
          data.types = this.getMapValuesByFloorTabType(tab,'def');
          
          this.$http
            .get(url, data).then((resq) => {
              if (res.state == 1 || priorityData) {
                _this.setTabValuesByFloorTabType(tab, [...(res.data ? res.data : ''),...(resq.data ? resq.data : '')], firstTab,priorityData,state);
              }else if( !res.state && !_this.newAppId ){
                _this.getContent ++ ;
              }
            })
        })
    },
    //轮播图
    swiperFn () {
      let _this = this;
      
      _this.$nextTick(() => {
        var width = (this.$refs.rightContent.offsetWidth - 2 - 40 - (_this.preNum - 1)*20 -2 ) / _this.preNum; 
        $('.bottom-content' + _this.swiperInd + _this.indexs + ' li').width(width);
        // $('.bottom-content' + _this.swiperInd + _this.indexs + ' li:eq('+ (_this.preNum -1 ) +')').css('margin-right',0);
        // _this.mySwiper = new window.Swiper('.bottom-content' + _this.swiperInd + _this.indexs, {
        //   slidesPerView: _this.preNum,
        //   slidesPerGroup: _this.preNum,
        //   observer: true, //修改swiper自己或子元素时，自动初始化swiper
        //   observeParents: true,
        //   // noSwiping: true,
        //   // autoplay: (_this.blockData.floorSlideshow != 'on' && (_this.centerStyle != 'banner' || _this.centerStyle != 'companyIntroduce')) ? false : true,
        //   spaceBetween: 20,
        //   // navigation: {
        //   //   nextEl: '.arrow-right' + _this.swiperInd + _this.indexs,
        //   //   prevEl: '.arrow-left' + _this.swiperInd + _this.indexs,
        //   // },
        //   // on: {
        //   //   touchEnd: function (swiper, event) {
        //   //     if (_this.mySwiper.isEnd && _this.mySwiper.swipeDirection == "next") {
        //   //       _this.arrowRight();
        //   //     }
        //   //   }
        //   // }
        // })
        // // _this.mySwiper.navigation.update();
        // if (_this.mySwiper && _this.pageNum != 1 && !_this.mySwiper[0]) {
        //   _this.mySwiper.slideTo((_this.pageNum - 1) * _this.preNum);
        // } else if (_this.mySwiper && _this.mySwiper[0]) {
        //   _this.mySwiper[0].slideTo((_this.pageNum - 1) * _this.preNum);
        // }
      })
    },
    arrowRight () {
      var data={ appId: this.getQuery('appId'), floorFlowId:this.blockData.id,zzBlockId:this.newId,zxBlockId:this.basicTypes?this.newId:'',newAppId:this.basicTypes?'':this.newAppId,upBlockId:this.upBlockId,flowEnName:this.blockData.flowEnName};
      // this.$router.push({ path: 'flowList', query: data});
      this.routerJump('push','flowList',data,'更多');

      // var _this = this; 
      // if (_this.mySwiper.activeIndex == (_this.pageNum - 1) * _this.preNum && _this.nowLength == _this.preNum || _this.mySwiper && _this.mySwiper[0] && _this.mySwiper[0].activeIndex == (_this.pageNum - 1) * _this.preNum && _this.nowLength == _this.preNum) {
      //   _this.pageNum += 1;
      //   if(_this.centerContent){
      //     _this.getCenterContent();
      //   }else if(_this.priorityData.length){
      //     _this.getPriorityData();
      //   }else if (_this.nowFlowTab.item.flowType == 'flow') {
      //     _this.getTagsByFlowId(_this.blockId, _this.pageNum, _this.nowFlowTab.param, '', '', { orgType: '' });
      //   } else if (_this.blockData.flowEnName == 'meta-universe' || _this.nowFlowTab.param.tabType == 'left' || (_this.blockData.flowEnName == 'media-scene' && _this.nowFlowTab.param.tabType == 'up')||_this.nowFlowTab.item.flowType == 'block') {
      //     if(_this.nowFlowTab.item.basicTypes == '6'){
      //       this.getTagsByBlockId(_this.nowFlowTab.item, _this.nowFlowTab.param, '',{url:'/zciid-deliverable/showPlatformStyle/flow/api/getContentArrByBlockId.json'});
      //     }
      //     _this.getTagsByBlockId(_this.nowFlowTab.item, _this.nowFlowTab.param, '', '', '', { orgType: '' });
      //   }
      //   _this.addContent = true;
      // }
    },
    //获取立项项目信息
    getProjectInfo (id) {
      this.$http
        .get("/acnid-project-approve/flowScore/info/project-flowId-list.json", {
          appId: id
        }).then(res => {
          this.treeOragin = [];
          if (res.state == 1) {
            res.data.forEach((ite) => {
              this.treeOragin.push({
                id: ite.professionId,
                appId: id,
                name: ite.professionName,
                sceneId: ite.sceneId,
                groupId: ite.groupId,
                dataType: 1
              })
            })

          }
        })
    },
    //获取立项项目信息
    getTree (data, node) {
      this.nodeExpand(data, node);
      var id = data.id;
      this.$http
        .get("/acnid-project-approve/scenarioinfo/bsysprofession/api/info.json", {
          professionId: id,
          restrictParams: '1'
        }).then(res => {
          this.ProjectInfo = null;
          if (res.state == 1) {
            this.ProjectInfo = res.data;
          }
        })
    },
    setContentId (ite) {
      if (ite.contentId) {
        if (!window.$rightLeft) {
          window.$rightLeft = {}
        }
        window.$rightLeft.center = {
          contentId: ite.contentId,
          contentShowRowsSort: ite.contentShowRowsSort
        }
      }
    },
    setProfessionId (ite) {
      window.$professionId = ite.professionId ? ite.professionId : ite.id
    },
    loadNode (node, resolve) {
      this.noData = false;
      if (node.level === 0) {
        return resolve(this.treeOragin);
      }
      this.professionId = node.data.id;
      // this.getTree(node.data);
      if (node.data.dataType == 3) {
        this.noData = true;
        return resolve([])
      }
      this.$http
        .get("/acnid-project-approve/board/workbench/getNextDataListJson", {
          appId: node.data.appId,
          sceneId: node.data.sceneId,
          groupId: node.data.groupId,
          level: node.level
        }).then(res => {
          if (res.state == 1) {
            var item = [];
            //拼接 table参数
            var i = 0;
            var options = [{
              prop: 'cassName',
              label: "立项架构平台",
              width: "180",
              sTyle: 'red'
            }];
            var propsData = {};
            propsData.cassName = node.data.name;
            if (res.data.infoList.length == 0) {
              this.noData = true;
            }
            res.data.infoList.filter((ite) => {
              if (ite.productName) {
                item.push({
                  appId: ite.appId,
                  id: ite.professionId,
                  name: ite.productName,
                  sceneId: ite.sceneId,
                  groupId: ite.groupId,
                  dataType: ite.dataType,
                  funUrl: ite.funUrl ? `${ite.funUrl}/?appId=${ite.appId}&pfId=${ite.pfId}&flowId=${ite.flowId}` : ''
                })

                propsData['cusProductName' + i] = '';

                options.push({
                  prop: 'cusProductName' + i,
                  label: ite.productName,
                  width: "180",
                  sTyle: ite.dataType == 3 ? 'blue' : 'black'
                })

              }
            })
            this.table.propsData = [propsData];
            this.table.options = options;
            resolve(item)
          }
        })
    },
    nodeExpand (data, node) {
      this.noData = false;
      if (node.data.dataType == 3) {
        this.table.propsData = [];
        this.table.options = [];
        this.noData = true;
        return false
      }
      this.$http
        .get("/acnid-project-approve/board/workbench/getNextDataListJson", {
          appId: node.data.appId,
          sceneId: node.data.sceneId,
          groupId: node.data.groupId,
          level: node.level
        }).then(res => {
          if (res.state == 1) {
            //拼接 table参数
            var i = 0;
            var options = [{
              prop: 'cassName',
              label: "立项架构平台",
              width: "180"
            }];
            var propsData = {};
            propsData.cassName = node.data.name;
            if (res.data.infoList.length == 0) {
              this.noData = true;
            }
            res.data.infoList.filter((ite) => {
              if (ite.productName) {
                propsData['cusProductName' + i] = '';
                options.push({
                  prop: 'cusProductName' + i,
                  label: ite.productName,
                  width: "180"
                })
              }
            })
            this.table.propsData = [propsData];
            this.table.options = options;
          }
        })
    },
    //获取下级立项平台数据
    handleMore (item) {
      var page = 1;
      var _this = this;
      _this.flowNewList = [];
      function getFlowDataPage (page) {
        _this.$http
          .get("/zciid-deliverable/api/webapp/get/data.json", {
            // appId: _this.blockData.appId,
            appId: _this.getQuery('appId'),
            flowId: item.id,
            pageSize: 2,
            pageNum: page
          }).then(res => {
            if (res.state == 1 && res.data) {
              _this.flowNewList.push(...res.data);
              _this.flowStep = 1;
            } else {
              clearInterval(_this.timer);
              if (page <= 1) {
                _this.getProduct();
              }
              page = 1;
            }
          })
      }
      _this.timer = setInterval(function () {
        getFlowDataPage(page++)
      }, 300);
    },
    // windowRightMenu (ev) {
    //   this.$store.commit('setFlowType', this.blockData.floorType);
    //   window.$floorflowId = this.blockData;
    //   window.$nodeId = this.nodeId;
    //   this.tagsMenuPos.left = ev.pageX;
    //   this.tagsMenuPos.top = ev.pageY;
    //   this.$emit('contmenuo', { tagsName: this.tagsName, tagsValue: this.tagsValue });
    // },
    handleNextFlow (ite) {
      this.flowStep++;
      if (!ite.appId) {
        this.$http
          .get("/zciid-deliverable/api/webapp/get/data.json", {
            // appId: this.blockData.appId,
            appId: this.getQuery('appId'),
            professionId: ite.id,
          }).then(res => {
            if (res.state == 1) {
              this.flowNewList = res.data;
              // this.swiperFn()
            }
          })
      } else {
        this.getProjectInfo(ite.appId);
      }
    },
    handleDetail (ite, data) {
      window.$nodeId = this.nodeId;
      this.nodeId = ite.nodeId;


      // this.blockId = ite.blockId;
      sessionStorage.setItem('floorDetailShow', this.floorDetailShow);
      var blockId = this.blockId;
      var contentId = ite.contentId ? ite.contentId : this.contentId;

      sessionStorage.setItem('originName', JSON.stringify({ blockId: blockId, contentId: contentId }));
      this.$blockGetData.handleDetail(this, ite, this.blockData.flowEnName, data);
    },
    setDefaultTags () {
      let _this = this;
      for (var i = 0; i < 10; i++) {
        _this.listData.push({
          id: '',
          pictures: [require('../../assets/image/images/default_media.png')],
          others: [{ standardData: '' }, { standardData: '' }],
          tags: [{ standardName: '', standardData: '' }]
        })
      }
      _this.standardListJson = [];
      _this.flowStep = 4;
    },
    getProduct (pDataArr = []) {
      const _this = this;
      if (pDataArr.length == 0) {
        _this.setDefaultTags();
        return false;
      } else {
        if (_this.addContent) {
          _this.standardListJson.push(...pDataArr);
        } else {
          _this.standardListJson = pDataArr;
        }
        pDataArr.forEach((pData, index) => {
          var tags = [];
          var pictures = [];
          var others = [];
          var btns = [];
          if (!pData || !pData.standardJson) {
            _this.setDefaultTags();
            return false;
          } else {
            pData.standardJson.forEach((ele) => {
              // if(ele.isShow!='0'){
              if (ele.standardData && (ele.standardData.indexOf('.mp4') > 0 || ele.standardData.indexOf('.png') > 0 || ele.standardData.indexOf('.jpg') > 0 || ele.standardData.indexOf('.jpeg') > 0)) {
                pictures.push(ele.standardData);
              } else if (ele.standardType == 0) {
                others.push(ele);
              } else if (ele.standardType == 3) {
                btns.push(ele);
              }
              // }
              if (ele.isShow == 1 && ele.standardType != 3) {
                tags.push(ele);
              }
            });
            this.showList = this.showList == false ? true : true;
          }
          _this.flowStep = 4;
          _this.contentId = pData.contentId;
          _this.listData.push({
            id: pData.contentId,
            contentShowRowsSort: pData.contentShowRowsSort,
            sceneId: pData.sceneId,
            appName: pData.appName ? pData.appName : '',
            contentId: pData.contentId,
            sceneGroupId: pData.sceneGroupId,
            pictures: pictures.splice(0, 4),
            others: others.splice(0, 5),
            btns: btns.splice(0, 2),
            tags: tags.splice(0, 9),
            nodeId: pData.nodeId,
            contentWzUrl: pData.contentWzUrl,
            subDomain: pData.subDomain,
            ind: index,
            sign:pData.sign,
            appId:pData.appId
          })

        })
      }
      // _this.swiperFn();
    },
    getBlockTagsArr (pDataArr) {
      var listData = [];
      if (pDataArr.length == 0) {
        return listData;
      }
      pDataArr.forEach((pData) => {
        var tags = [];
        var pictures = [];
        var others = [];
        var btns = [];
        if (!pData || !pData.standardJson) {
          return false;
        } else {
          pData.standardJson.forEach((ele) => {
            if (ele.standardType == 0 && ele.standardData && (ele.standardData.indexOf('.flv') > 0 || ele.standardData.indexOf('.mp4') > 0 || ele.standardData.indexOf('.png') > 0 || ele.standardData.indexOf('.jpg') > 0 || ele.standardData.indexOf('.jpeg') > 0)) {
              pictures.push(ele.standardData);
            } else if (ele.standardType == 0) {
              others.push(ele);
            } else if (ele.standardType == 3) {
              btns.push(ele);
            }

            if (ele.isShow == 1 && ele.standardType != 3) {
              tags.push(ele);
            }
          });
        }
        //标签数据构造
        listData.push({
          id: pData.contentId,
          flowType: "tagsData",
          name: others.length && others[0].standardData ? others[0].standardData : '',
          contentShowRowsSort: pData.contentShowRowsSort,
          sceneId: pData.sceneId,
          contentId: pData.contentId,
          sceneGroupId: pData.sceneGroupId,
          pictures: pictures.splice(0, 2),
          others: others.splice(0, 5),
          btns: btns.splice(0, 2),
          tags: tags.splice(0, 9)
        })
      })
      return listData;
    },
    //通过流程获取标签
    getTagsByFlowId (fId, pageNum, param, datas, keyWord, item, area) {
      const _this = this;
      var AppId = _this.newId == 'falseBlockId' ? _this.newAppId : _this.$appId;
      // var AppId = _this.$appId;
      _this.setTagData();
      if (_this.mySwiper && _this.mySwiper[0] !== undefined) {
        _this.mySwiper[0].destroy();
      }
      if ( window.innerWidth <= 768 && (_this.centerStyle != 'banner' || _this.centerStyle != 'companyIntroduce')) {
        _this.preNum = 2;
      }
      if (_this.centerStyle.indexOf('smartAppSameScreenShow') == -1 && _this.centerStyle != 'smartApp') {
        _this.preNum = 10;
      }
      if (_this.centerStyle == 'flowArchShow') {
        _this.preNum = 5;
      }
      if (_this.centerStyle == 'banner' || _this.centerStyle == 'companyIntroduce') {
        _this.preNum = 1;
      }
      var specailFloor = ['qualification-honor','library','biz-circle','customer-alliance','media-scene'];
      var url = "/zciid-deliverable/showPlatformStyle/flow/api/getContentDataByflowId.json",
        data = { appId: AppId, flowId: fId, pageSize: _this.preNum, pageNum: pageNum, keyWord: keyWord ? keyWord : '' ,isMedia: _this.getQuery('isMedia') ? _this.getQuery('isMedia') : (_this.blockData&&specailFloor.includes(_this.blockData.flowEnName) ?'1':'0'),domainNameType: document.location.pathname.split('/')[1],leftId:_this.newId,floorEnName:_this.blockData.flowEnName};
      //图书馆、客户组织联盟层
      var array = ['library', 'customer-alliance'];
      
      if (param.tabType == 'left') {
        url = "/zciid-deliverable/showPlatformStyle/flow/api/getLeftBlockByFlowOrBlockId.json",
          data = { appId: AppId, flowOrBlcokId: fId, keyWord: keyWord ? keyWord : '', pageSize: _this.preNum, pageNum: pageNum,floorEnName:_this.blockData.flowEnName }
      }
      var arras = ['live-display','media-broadcast','product-streaming','live-training'];
      if(param.tabType != 'left' && arras.includes(_this.blockData.flowEnName)){
        url = "/zciid-deliverable/api/showPlatform/content/getLiveStreamingContentByFlowOrBlockId.json",
        data = {appId:_this.$appId,flowOrBlockId:item.id,keyWord: keyWord ? keyWord : '',leftId:_this.newId, pageSize: _this.preNum, pageNum: _this.pageNum }
      }
      //数据资产类型
      var arrs = ['data-asset','organizational-assets','platform-assets','special-asset','window-asset'];
      if(param.tabType != 'left' && arrs.includes(_this.blockData.flowEnName)){
        url = "/zciid-deliverable/api/showPlatform/content/getDataAssetPageByFlowId.json",
        data = {appId:_this.$appId,flowId:item.id,keyWord: keyWord ? keyWord : '',leftId:_this.newId, pageSize: _this.preNum, pageNum: _this.pageNum }
      }
      //联盟类型
      var arrs = ['member-alliance','metacosmic-alliance','metacosmic-agent','metacosmic-join','metacosmic-investment'];
      if(param.tabType != 'left' && arrs.includes(_this.blockData.flowEnName)){
        url = "/zciid-deliverable/api/showPlatform/content/getDataUnionPageByFlowId.json",
        data = {appId:_this.$appId,flowId:item.id,keyWord: keyWord ? keyWord : '',leftId:_this.newId, pageSize: _this.preNum, pageNum: _this.pageNum }
      }
      if(_this.newId && _this.basicTypes){
        //第三方
        url = "/zciid-deliverable/showPlatformStyle/flow/api/getContentArrByBlockId.json",
        data = {blockId:_this.newId,wzAppId:_this.getQuery('appId'),floorFlowId:_this.blockData.id, pageSize: _this.preNum, pageNum: _this.pageNum,flowOrBlockId:item.id }
      }
      //标记选中id
      _this.checkedItemId = {id:item.id,fId:fId,pageNum:pageNum,param:param,datas:datas,keyWord:keyWord,item:item,area:area};
      _this.$http.get(url, data).then((res) => {
        if (res.state == 1 && res.data && res.data.length) {
          //记录当前交付物个数
          _this.nowLength =  res.data.length;
          if ( url.indexOf('getWzAppByFlowId') > -1) {
            var array = [];
            res.data.forEach((ele) => {
              var newObject = {};
              newObject.appId = 'sqsjyxglzpt';
              newObject.blockId = '';
              newObject.nodeId = '';
              newObject.contentId = ele.contentId;
              newObject.contentRows = '';
              newObject.contentShowFlowPosition = '';
              newObject.contentShowRowsSort = '';
              newObject.sceneGroupId = '';
              newObject.sceneId = '';
              newObject.isYyz = 0;
              newObject.userId = '';
              newObject.contentWzUrl = ele.wzUrl;
              newObject.blockDataType = '';
              newObject.releaseId = '';
              newObject.sign = '';
              newObject.standardJson = [{ 'standardName': '名称', 'standardData': ele.name, 'fileTypeDetail': '', 'standardType': 0, 'isShow': 1 }, { 'standardName': '头像', 'standardData': ele.photo, 'fileTypeDetail': '2' }];
              array.push(newObject);
            })
            _this.getProduct(array);
            // _this.swiperFn();
            return;
          }
          _this.getProduct(res.data);
          if (_this.centerStyle == 'banner') {
            _this.centers = 'banner';
          }
        } else {
          if (pageNum == 1) {
            _this.getProduct();
          } else {
            _this.flowStep = 4
          }
        }
        // _this.swiperFn();
      })
    },
    //通过流程请求下级
    getFlowOrBlockByFlowId (item, param, keyWord, area) {
      var _this = this;
      _this.flowId = item.id;
      var url='/zciid-deliverable/showPlatformStyle/flow/api/get/getFlowFloorDataSpit.json',
      data={
          appId: (_this.newId == 'falseBlockId' && param.tabType != 'left') ? _this.newAppId : _this.getQuery('appId'),
          // appId: _this.$appId,
          flowId: item.id,
          diyPageFlowId: '',
          floorEnName:_this.blockData.flowEnName,
          domainNameType: document.location.pathname.split('/')[1],
          isBlock: (_this.blockData.flowEnName == 'meta-universe' || param.tabType == 'left'  || param.tabType == 'up') ? (item.orgType != '-1' ? 'newType' : 'yes') : '',
          userId: _this.$store.state.userInfo.userId,
          leftId: _this.basicTypes ? '' : _this.newId};
      var arrays=['OrgBizCircle','SpecialPlatform','GovernmentOrgBizCircle','EnterprisesOrgBizCircle','SpecialOrgBizCircle','CustomOrgBizCircle','IntelligentMan','SpecialSocialPlatform','SpecialServicePlatform','SpecialEquipmentPlatform','SpecialMailboxPlatform'];
      if(param.tabType == 'left'&&item.enName != 'IntelligentMan'&& arrays.indexOf(item.enName) > -1){
        url = '/zciid-deliverable/showPlatformStyle/flow/api/getBlockIdByFlowId.json';
        data.floorEnName = _this.blockData.flowEnName;
      }
      _this.$http
        .get(url, data).then(res => {
          if (res.state == 1) {
            if (_this.centerStyle == 'flowArchShow') {
              _this.floorTabShow = [];
              if (_this.$refs.rightContent) {
                _this.$refs.rightContent.style.border = 0;
              }
            } else {
              if (_this.$refs.rightContent) {
                _this.$refs.rightContent.style.border = '1px solid #ddd';
              }
            }
            var array = ['main-products', 'related-products', 'project-products', 'second-hand', 'project-performance'],
              arr = ['meta-universe', 'biz-circle', 'product-performance', 'library','data-asset'];
            // if (!(arr.indexOf(_this.blockData.flowEnName) == -1 && param.tabType == 'up') || (array.indexOf(_this.blockData.flowEnName) > -1 && param.tabType == 'up')) {
            if(param.tabType != 'left'){
              _this.centerStyle = res.data[0].floorStyle ? res.data[0].floorStyle : _this.blockData.floorType;
              _this.getTagsByFlowId(item.id, 1, param, res.data, keyWord, item, area);
            }
              
            // }

            if (_this.centerStyle == 'banner') {
              _this.centers = 'banner';
            }
            //刚改的
            // this.handleTabDataAll(item, param, res.data);
          }
        })
    },
    //tab切换数据处理
    handleTabDataAll (item, param, resData) {
      const _this = this;
      if (resData && resData[0] && resData[0].dataArr && resData[0].dataArr.length > 0) {

        if (item.flowType == "flow") {
          _this.leftTabInd = 0;
          if (param.tabType == 'up' && param.refesh) {
            _this.nodeNavTop = resData[0].dataArr;
            _this.nodeNavTop.unshift(item);
            console.log(_this.nodeNavTop);
            
          }
          //中间点击
          if (param.tabType == 'center' && param.refesh) {
            _this.blockCenterList = resData[0].dataArr;
            _this.blockCenterList.unshift(item);
          }
          //左侧tab点击
          if (param.tabType == 'left' && param.refesh) {
            // _this.nodeNavLeft = resData[0].dataArr
            // _this.nodeNavLeft.unshift(item);
            if (_this.isQuote) {
              var leftRes = _this.getLeftCircleSelectValues(item);
              leftRes.then(res => {
                if (res.state == 1) {
                  _this.isQuote = true;
                  _this.nodeNavLeft = [];
                  if (res.data.circleArr) {
                    _this.nodeNavLeft.push(...res.data.circleArr);
                  }
                  if (res.data.childFlowArr) {
                    _this.nodeNavLeft.push(...res.data.childFlowArr);
                  }
                  _this.nodeNavLeft.unshift(item);
                } else {
                  _this.nodeNavLeft = resData[0].dataArr;
                  _this.nodeNavLeft.unshift(item);
                }
              })
            } else {
              _this.nodeNavLeft = resData[0].dataArr
              _this.nodeNavLeft.unshift(item);
            }
          }
          //右侧tab点击
          if (param.tabType == 'right' && param.refesh) {
            _this.nodeNavRight = resData[0].dataArr
            _this.nodeNavRight.unshift(item);
          }
          //下侧tab点击
          if (param.tabType == 'down' && param.refesh) {
            _this.nodeNavDown = resData[0].dataArr
            _this.nodeNavDown.unshift(item);
          }
          //解决流程点击不显示默认图片问题
          // _this.handleMore(item);
          _this.filterTagData2(_this.nodeNav);
          // _this.swiperFn();
        }
      } else if (!(this.blockData.flowEnName != 'meta-universe' && this.blockData.flowEnName != 'biz-circle' && param.tabType == 'up')) {
        _this.setDefaultTags();
      }
    },
    //通过流程块请求标签（非左侧组织架构）
    getTagsByBlockId (item, param, keyWord) {
      const _this = this;
      if(!_this.basicTypes){
        _this.setTagData();
      }
      if ( window.innerWidth <= 768 && (_this.centerStyle != 'banner' || _this.centerStyle != 'companyIntroduce')) {
        // return false;
        _this.preNum = 2;
      }
      if (_this.centerStyle.indexOf('smartAppSameScreenShow') == -1 && _this.centerStyle != 'smartApp') {
        _this.preNum = 10;
      }
      if (_this.centerStyle == 'flowArchShow') {
        _this.preNum = 5;
      }
      if (_this.centerStyle == 'banner' || _this.centerStyle == 'companyIntroduce') {
        _this.preNum = 1;
      }
      if (_this.mySwiper && _this.mySwiper[0] !== undefined) {
        _this.mySwiper[0].destroy();
      }
      //有sqData展示数据
      if (item.blockDataType == 3) {
        if (item.sqData.length) {
          var array = [];
          item.sqData.forEach((ele) => {
            var newObject = {};
            newObject.flowType = 'block';
            newObject.name = ele.circleName;
            newObject.id = ele.circleId;
            newObject.hasQuote = '';
            newObject.isSq = 4;
            newObject.wzUrl = '';
            item.sqData = [];
            array.push(newObject);
          })
          _this.leftTabInd = 0;
          _this.nodeNavLeft = array;
          _this.nodeNavLeft.unshift(item);
        }
        return;
      }
      var AppId = _this.newId == 'falseBlockId' ? _this.newAppId : _this.getQuery('appId');
      // var AppId = _this.getQuery('appId');
      var specailFloor = ['qualification-honor','library','biz-circle','customer-alliance','media-scene'];
      var url = "/zciid-deliverable/showPlatformStyle/flow/api/get/getContentDataByBlockNodeId.json",
        data = { appId: AppId, blockId: item.id, nodeId: item.nodeId, keyWord: keyWord ? keyWord : '' ,isMedia: _this.getQuery('isMedia') ? _this.getQuery('isMedia') : (_this.blockData&&specailFloor.includes(_this.blockData.flowEnName) ?'1':'0'),domainNameType: document.location.pathname.split('/')[1], pageSize: _this.preNum, pageNum: _this.pageNum,leftId:_this.newId,floorEnName:_this.blockData.flowEnName};

      //图书馆、客户组织联盟层
      var array = ['library', 'customer-alliance'];
      //元宇宙、客户组织联盟、外展商圈主展示
      var arrs = ['meta-universe','customer-alliance','biz-circle'];


      if (param.tabType == 'left') {
        url = "/zciid-deliverable/showPlatformStyle/flow/api/getLeftBlockByFlowOrBlockId.json",
          data = { appId: AppId, flowOrBlcokId: item.id, keyWord: keyWord ? keyWord : '', pageSize: _this.preNum, pageNum: _this.pageNum ,khType:item.khType,floorEnName:_this.blockData.flowEnName}
      } 
      
      var appId;
      if (_this.blockData.flowEnName == 'media-scene' && param.tabType == 'up') {
        url = '/zciid-deliverable/showPlatformStyle/flow/api/getFloorUpContentByBlockId.json';
        data = { appId: AppId, blockId: item.id,leftId:_this.newId, pageSize: _this.preNum, pageNum: _this.pageNum ,floorEnName:_this.blockData.flowEnName};
        appId = _this.getQueryUrl(item.pageUrl, 'appId');
        switch (appId) {
          case 'zjtpgyyzs':
            url = '/meeting-tool-web/interface/meeting/webMeta/query';
            data = { pageSize: _this.preNum, pageNum: _this.pageNum };
            break;
          case 'tpbjgyyzs':
            url = '/aassid/cms/client/api/platform/abduceList.json';
            data = { userId: _this.$store.state.userInfo.userId, pageSize: _this.preNum, pageNum: _this.pageNum }
            break;
          case 'tpzbgyyzs':
            url = '/meeting-tool-web/interface/meeting/communication/query';
            data = { communicationType: '186', pageSize: _this.preNum, pageNum: _this.pageNum };
            break;
        }
      }
      var arras = ['live-display','media-broadcast','product-streaming','live-training'];

      if(param.tabType != 'left' && arras.includes(_this.blockData.flowEnName)){
        url = "/zciid-deliverable/api/showPlatform/content/getLiveStreamingContentByFlowOrBlockId.json",
        data = {appId:_this.$appId,flowOrBlockId:item.id,keyWord: keyWord ? keyWord : '',leftId:_this.newId, pageSize: _this.preNum, pageNum: _this.pageNum }
      }
      //联盟类型
      var arrs = ['member-alliance','metacosmic-alliance','metacosmic-agent','metacosmic-join','metacosmic-investment'];
      if(param.tabType != 'left' && arrs.includes(_this.blockData.flowEnName)){
        url = "/zciid-deliverable/api/showPlatform/content/getDataUnionPageByFlowId.json",
        data = {appId:_this.$appId,flowId:item.id,keyWord: keyWord ? keyWord : '',leftId:_this.newId, pageSize: _this.preNum, pageNum: _this.pageNum }
      }
      if(_this.newId && _this.basicTypes){
        //第三方
        url = '/zciid-deliverable/showPlatformStyle/flow/api/getContentArrByBlockId.json';
        data = {blockId:_this.newId,wzAppId:_this.getQuery('appId'),floorFlowId:_this.blockData.id, pageSize: _this.preNum, pageNum: _this.pageNum,flowOrBlockId:param.tabType == 'left' ? '' : item.id }
      }
      //标记选中id
      _this.checkedItemId = {id:item.id,item:item,param:param, keyWord:keyWord};
      _this.$http
        .get(url, data).then(res => {
          if (res.state == 1 && res.data && res.data.length) {
            //记录当前交付物个数
            _this.nowLength = res.data.length;
            var arr = ['biz-circle', 'product-performance', 'library','data-asset'];
            if ( url.indexOf('getWzAppByFlowId') > -1) {
              var array = [];
              res.data.forEach((ele) => {
                var newObject = {};
                newObject.appId = 'sqsjyxglzpt';
                newObject.blockId = '';
                newObject.nodeId = '';
                newObject.contentId = ele.contentId;
                newObject.contentRows = '';
                newObject.contentShowFlowPosition = '';
                newObject.contentShowRowsSort = '';
                newObject.sceneGroupId = '';
                newObject.sceneId = '';
                newObject.isYyz = 0;
                newObject.userId = '';
                newObject.contentWzUrl = ele.wzUrl;
                newObject.blockDataType = '';
                newObject.releaseId = '';
                newObject.sign = '';
                newObject.standardJson = [{ 'standardName': '名称', 'standardData': ele.name, 'fileTypeDetail': '', 'standardType': 0, 'isShow': 1 }, { 'standardName': '头像', 'standardData': ele.photo, 'fileTypeDetail': '2' }];
                array.push(newObject);
              })
              _this.getProduct(array);
              // _this.swiperFn();
              return;
            }

            _this.centerStyle = res.data[0].floorStyle ? res.data[0].floorStyle : _this.blockData.floorType;

            if ( window.innerWidth <= 768 && (_this.centerStyle != 'banner' || _this.centerStyle != 'companyIntroduce')) {
              // return false;
              _this.preNum = 2;
            }
            if (_this.centerStyle.indexOf('smartAppSameScreenShow') == -1 && _this.centerStyle != 'smartApp') {
              _this.preNum = 10;
            }
            if (_this.centerStyle == 'flowArchShow') {
              _this.preNum = 5;
            }
            if (this.centerStyle == 'banner' || this.centerStyle == 'companyIntroduce') {
              _this.preNum = 1;
            }
            if (res.data[0].floorStyle) {
              if (res.data[0].floorStyle == 'flowArchShow') {
                _this.floorTabShow = [];
                this.$refs.rightContent.style.border = 0;
              } else {
                this.$refs.rightContent.style.border = '1px solid #ddd';
              }
            } else if (param.refesh) {
              _this.centerStyle = _this.centerStyles;
              if (_this.centerStyles == 'flowArchShow') {
                _this.floorTabShow = [];
                this.$refs.rightContent.style.border = 0;
              } else {
                this.$refs.rightContent.style.border = '1px solid #ddd';
              }
            };
            if (_this.centerStyle == 'banner') {
              _this.centers = 'banner';
            }
            _this.filterTagData(res.data);
            if (param.tabType == 'center') {
              var tagsArr = _this.getBlockTagsArr(res.data);
              _this.leftTabInd = 0;
              _this.blockCenterList = tagsArr;
              _this.blockCenterList.unshift(item);
            } else {
              //传媒场景层上侧除外
              if (!(_this.blockData.flowEnName == 'media-scene' && param.tabType == 'up')) {
                _this.listData = [];
              } else if (appId == 'zjtpgyyzs' || 'tpbjgyyzs' || 'tpzbgyyzs') {
                for (var i = 0; i < res.data.length; i++) {
                  if (res.data[i].standardJson.length) {
                    for (var j = 0; j < res.data[i].standardJson.length; j++) {
                      var data = res.data[i].standardJson[j].standardData;
                      if (this.isPic(data)) {
                        res.data[i].standardJson[j].fileTypeDetail = '2';
                        break;
                      } else if (this.isVideo(data)) {
                        res.data[i].standardJson[j].fileTypeDetail = '1';
                        break;
                      } else if (this.isFile(data)) {
                        res.data[i].standardJson[j].fileTypeDetail = '4';
                        break;
                      }
                    }
                  }
                }
              }
              
              _this.getProduct(res.data)
              _this.flowStep = 4
            }
          } else if (this.pageNum == 1) {
            this.standardListJson = [];
            // _this.swiperFn();
          }
        })
    },
    //左侧流程块 引用点击请求（引用流程数据）
    getFlowByBlockId (item) {
      this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/get/getQuoteFlowByBlockId.json", {
          appId: _this.newAppId ? _this.newAppId : _this.getQuery('appId'),
          blockId: item.id
        }).then(res => {
          if (res.state == 1) {
            if (this.centerStyle == 'banner') {
              this.centers = 'banner';
            }
          }
        })
    },
    changeFlowTab (item, param, searchValue, area) {
      this.checkedItemId = {id:''};
      this.priorityData = [];
      //右键搜索框内容 searchValue
      this.$store.commit('searchContent', '');
      this.addContent = false;
      this.pageNum = 1;
      if (!item) {
        this.getProduct();
        return false 
      }
      this.iframeSrc = '';
      //记录点击参数
      this.nowFlowTab = { item: item, param: param };
      
      if (item.pageUrl && item.pageUrl != 'javascript:;' && param.tabType != 'left') {
        var arr = ['meta-universe', 'media-scene'],
          array = ['biz-circle', 'product-performance', 'library','data-asset'];
        if (arr.indexOf(this.blockData.flowEnName) == -1) {
          if (array.indexOf(this.blockData.flowEnName) == -1) {
            return false;
          }
        }
      }
      this.swiperInd = item.id ? (item.id + this.blockData.id) : '';
      this.tabActiveType = param.tabType;
      const _this = this;
      this.nodeId = '';
      if (!(this.blockData.flowEnName != 'meta-universe' && this.blockData.flowEnName != 'biz-circle' && param.tabType == 'up')) {
        // this.standardListJson = [];
      }

      clearInterval(this.timer);
      if (item.flowType == "flow") {
        this.flowId = item.id;
        this.blockId = item.id;
        this.listData = [];
        this.getFlowOrBlockByFlowId(item, param, searchValue, area);
      } else if (item.flowType == "block") {
        _this.leftTabInd = param.activeTab;
        this.blockId = item.id;
        this.nodeId = item.nodeId;
        this.listData = [];
        //点击左侧流程块，请求对应流程块的appId交付物
        if(param.tabType == 'up'){
          this.upBlockId = item.id;
        }else{
          this.upBlockId = '';
        }
        if(param.tabType == 'left'){
          this.newId = item.id;
          if(item.basicTypes != '6'){
            //不是第三方
            if(item.pageUrl && this.getQueryUrl(item.pageUrl,'appId')){
              this.newAppId = this.getQueryUrl(item.pageUrl,'appId');
            }else{
              return;
            }
            var { id } = this.blockData;
            this.filterTagData2(this.blockData.dataArr);
            _this.$http
              .get('/zciid-deliverable/showPlatformStyle/flow/api/getFlowIdByEnName.json', {
                flowId:id,
                blockId:item.id,
                appIdStr:item.id == 'falseBlockId' ? item.appId : ''
              }).then(res => {
                if (res.state == 1 && res.data && res.data.length) {
                  this.getTabBlock(res.data);
                }
              })
              this.basicTypes = false;
          }else{
            //是第三方
            this.basicTypes = true;
            var { id } = this.blockData;
            this.getTabBlock(id,item, param, searchValue);
          }
          
          
          return;
        }

        if (item.hasQuote == 'isQuote') {
          this.getFlowByBlockId(item);
        }
        this.getTagsByBlockId(item, param, searchValue);
      }
    },
    filterTagData (blockData) {
      var names = [];
      var contents = [];
      if (blockData.length > 0) {
        for (var b in blockData) {
          var itemCon = [];
          blockData[b].standardJson.forEach((ele) => {
            if (ele.standardType == 0 && ele.standardName && ele.standardName != '') {
              if (b == 0) {
                names.push(ele.standardName);
              }
              itemCon.push(ele.standardData);
            }

          });
          contents.push(itemCon);
        }
      }
      this.tagsName = names;
      this.tagsValue = contents;
    },
    filterTagData2 (nodeNavList) {
      var contents = [];
      if (nodeNavList.length > 0) {
        for (var b in nodeNavList) {
          if (b > 0) {
            contents.push([nodeNavList[b].name]);
          }
        }
        this.tagsName = [nodeNavList[0].name];
        this.tagsValue = contents;
      }

    },
    //刷新数据
    refeshData () {
      this.basicTypes=false;
      this.flowNewList = [];
      this.pageNum = 1;
      this.newId = '';
      this.listData = [];
      this.standardListJson = [];
      this.tabActiveType = 'down'
      this.flowStep = 0
      this.leftTabInd = 0
      this.preNum = window.innerWidth <= 768 ? 2 : 5,
      // this.$backArr = [];
      this.newAppId = '';
      this.priorityData = [];
      this.nowLength = 0;
      // this.addContent = false;
      var { id } = this.blockData;
      this.filterTagData2(this.blockData.dataArr);
      this.getTabBlock(id,'','','','first');
      this.rightSrc = ''
    }
  }
}
</script>
<style scoped lang="scss">
.right-content {
  border: 1px solid#ddd;
  box-sizing: border-box;
  .bottom-switch {
    padding: 18px 20px 18px 0;
    .bottom-content {
      overflow: hidden;
      // 树形菜单
      .watch {
        width: 100%;
        max-height: 100%;
        overflow: hidden;
        line-height: 32px;
        .version {
          font-size: 14px;
          width: 100%;
          word-break: keep-all;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .multistage-left {
          padding-right: 18px;
          width: 282px;
          height: 324px;
          overflow: auto;
        }
        .blue-right {
          padding-left: 18px;
          width: 228px;
          height: 324px;
          overflow: auto;
        }
        .blue-right .version a:hover {
          background-color: #fafafa;
        }
        .blue-right a {
          color: #2f8eed;
          display: block;
          height: 32px;
          width: 100%;
          word-break: keep-all;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .black-center {
          padding: 0 16px;
          border-left: 1px dashed #ddd;
          border-right: 1px dashed #ddd;
          width: calc(100% - 580px);
          height: 324px;
          overflow: auto;
        }
      }
      .no-data {
        color: #999999;
        font-size: 16px;
        text-align: center;
        margin-top: 20px;
      }
      .no-data.white {
        color: #fff;
        font-size: 12px;
        text-align: left;
        margin-top: 0px;
      }
    }
    //企业简介样式
    &.companyIntroduce {
      .bottom-content {
        ul {
          li {
            border: none;
            > a {
              position: relative;
              clear: both;
              width: 100%;
              img {
                float: left;
                width: 50%;
              }
              .li_hover {
                width: calc(50% - 40px);
                background: #fff;
                float: left;
                position: static;
                padding: 0 20px;
                .li_hover_title {
                  color: #333333;
                }
                .li_hover_conter {
                  color: #333333;
                  width: 100%;
                }
              }
            }
          }
        }
      }
    }
    &.banner {
      .bottom-content {
        ul {
          li {
            border: none;
            > a {
              .li_hover {
                display: none;
              }
            }
          }
        }
      }
    }
  }
}
#smart-intel-product
  .outreach_content
  .block-content
  .right-content
  .bottom-switch.smartAppSameScreenShow.expertsAlliance {
  height: 326px;
}
#smart-intel-product
  .outreach_content
  .block-content
  .right-content
  .bottom-switch.smartAppSameScreenShow.enterprisAlliance {
  height: 232px;
}
#smart-intel-product
  .outreach_content
  .block-content
  .right-content
  .bottom-switch.smartAppSameScreenShow.service-box {
  height: 232px;
}

@media screen and (min-width: 768px) {
  .slide {
    width: 230px;
    margin: 0;
  }
}
@media screen   and (max-width: 768px) {
  .right-content .bottom-switch .bottom-content ul {
    width: 100%;
  }
  // .right-content .bottom-switch {
  //   height: 230px;
  //   margin-top: -10px;
  // }
  // .swiper-wrapper{display:block;width:100%!important;}
  .right-content .bottom-switch .bottom-content ul li {
    width: calc(50% - 5px);
    width: -webkit-calc(50% - 5px);
    margin-top: 10px;
    margin-right: 17px !important;
    height: 240px;
    overflow: hidden;
  }
  .right-content .bottom-switch.companyIntroduce .bottom-content ul li {
    width: 100%;
    height: 240px;
    overflow: hidden;
  }
  // .right-content .bottom-switch .bottom-content ul li:nth-of-type(even){margin-right:0!important;}
  .right-content .bottom-switch .bottom-content ul li > a .li_hover {
    bottom: -210px;
  }
  .right-content .bottom-switch .bottom-content:hover .arrow-left,
  .right-content .bottom-switch .bottom-content:hover .arrow-right {
    display: none;
  }
  .right-content .bottom-switch .bottom-content .watch .black-center {
    width: 100%;
    padding: 0;
    border: none;
  }
  .right-content
    .bottom-switch
    .bottom-content
    ul
    li
    > a
    .li_hover
    .li_hover_title {
    font-size: 14px;
    height: 30px;
    line-height: 30px;
  }
  .right-content .bottom-switch .bottom-content ul li > a .li_hover .img_right {
    line-height: 14px;
    height: 14px;
    width: 14px;
    top: 7px;
    right: 10px;
  }
  .right-content
    .bottom-switch
    .bottom-content
    ul
    li
    > a
    .li_hover
    .img_right::after {
    height: 4px;
    width: 4px;
    top: 5px;
    left: 4px;
  }
  .content-left-box,
  .content-right-box {
    width: 150px;
    position: absolute;
    top: 0px;
    bottom: 0px;
    z-index: 9;
    background: #fff;
    border-left: 1px solid #dddddd;
    border-right: 1px solid #dddddd;
    height: auto;
  }
  .content-left-box {
    left: 0;
  }
  .content-right-box {
    right: -1px;
  }
  // .block-content {
  //   position: relative;
  // }
  .outreach_content {
    position: relative;
  }
  .btn-left,
  .btn-right {
    position: absolute;
    top: 160px;
    width: 30px;
    height: 30px;
    border-radius: 20px;
    z-index: 8;
    background-size: contain;
  }
  .btn-left {
    left: 2px;
    background-image: url("~@/assets/image/images/icons/arrow_right_circular.png");
  }
  .btn-right {
    right: 2px;
    background-image: url("~@/assets/image/images/icons/arrow_left_circular.png");
  }
  .close-left,
  .close-right {
    position: absolute;
    top: 10px;
    width: 16px;
    height: 16px;
    border-radius: 10px;
    z-index: 10;
    background-size: contain;
    background-image: url("~@/assets/image/images/icons/close_right_top.png");
  }
  .close-left {
    left: 150px;
  }
  .close-right {
    right: 150px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/floorBlock/zncpMain.vue